import { render } from "./SendTestV4Modal.vue?vue&type=template&id=a0dc25ba&scoped=true"
import script from "./SendTestV4Modal.vue?vue&type=script&lang=ts"
export * from "./SendTestV4Modal.vue?vue&type=script&lang=ts"

import "./SendTestV4Modal.vue?vue&type=style&index=0&id=a0dc25ba&scoped=true&lang=scss"
import "./SendTestV4Modal.vue?vue&type=style&index=1&id=a0dc25ba&lang=scss"
script.render = render
script.__scopeId = "data-v-a0dc25ba"

export default script